import { Checkbox } from './checkbox.js';

export interface HideEmptyToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  testId?: string;
}

export function HideEmptyToggle({ checked, onChange, label, testId }: HideEmptyToggleProps) {
  return (
    <label className="inline-flex items-center gap-2 text-[12px] text-muted-foreground">
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => onChange(value !== false)}
        data-testid={testId}
      />
      {label}
    </label>
  );
}
